module.exports = __webpack_public_path__ + "img/ok.b3b2ae3e.png";